import CardInterface from './interface'

import { CardWrap } from './styles'

const Card = ({ children }: CardInterface) => <CardWrap>{children}</CardWrap>

export default Card
